import axios from 'axios';

export class ConsultAvailablePTTService {
    /**
     * Función que consulta el back para obtener la información
     * que se muesta en la pantalla "Consulta disponible PTT".
     * @param emisoraStr String con el cual se busca
     *                   Si viene vacío trae todos los datos
     * @returns {Promise<unknown>} Lista con la información a mostrar.
     */
    getDetailEmailAvailablePTM(idInstitucion) {
        return axios.get('/appapv/getDetailEmailAvailablePTM.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idInstitucion: idInstitucion,
            }
        }).then(res => res.data);
    }
}